import React, { useState, useRef, useEffect } from 'react';
import { convertTo12HourFormat } from '../../../utils/dateUtils';
import { usePermissions } from '../../../contexts/PermissionsContext';
import { useTranslation } from 'react-i18next';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { showWarningToast } from '../../../utils/toastHelper';
import { printView } from '../services/ordersService';
import {
  formatSpecification,
  trimDecimalZero,
} from '../../../utils/commonUtils';

const ViewOrderModal = ({
  setViewModal,
  selectedOrdersEdit,
  setAddModal,
  actionFrom,
  isOrdersCatering,
}) => {
  const { t } = useTranslation('Order');
  const { permissions } = usePermissions();

  const handleDownloadPdf = () => {
    const input = document.getElementById('add-order-modal');
    const buttons = document.querySelector('.header-button'); // Select the buttons container

    // Hide the buttons
    buttons.style.display = 'none';

    // Get the full height of the scrollable content
    const fullHeight = input.scrollHeight;

    // Use html2canvas to capture the full content
    html2canvas(input, {
      scale: 2, // Increase scale for better quality
      useCORS: true, // Use CORS to handle external images
      scrollY: -window.scrollY, // Adjust for scroll position
      height: fullHeight, // Set the height to the full scrollable height
      windowHeight: fullHeight, // Set the window height to the full scrollable height
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Add the image to the PDF
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

      // Save the PDF
      pdf.save('order-details.pdf');

      // Restore the buttons after capturing
      buttons.style.display = 'flex'; // or 'block', depending on your CSS
    });
  };
  const [downloadInfo, setDownloadInfo] = useState({});
  const [openDropdown, setOpenDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  const handleDownloadInfoChange = (e) => {
    setDownloadInfo((prev) => ({
      ...prev,
      company: e.target.value,
    }));
  };

  const handleDownload = async (type) => {
    if (!downloadInfo.company) {
      showWarningToast(t('PLEASESELECTCOMPANY'));
      return;
    }

    const queryData = {
      orderId: selectedOrdersEdit.id,
      type,
      company: downloadInfo.company,
    };
    await printView(queryData, type + '.pdf');
  };

  // Handle clicks outside the dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <div className="modal fade show d-block" id="add-order-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex justify-content-between w-95">
              <h1 className="modal-title fs-5">{t('VIEWORDER')}</h1>
              <div className="header-button">
                <div className="dropdown" ref={dropdownRef}>
                  <button className="print" onClick={toggleDropdown}>
                    <img src="images/print-without-border.svg" alt="Print" />
                  </button>

                  {openDropdown && (
                    <div className="dropdown-menu show print-drop-down">
                      <div className="dropdown-menu-list">
                        <label className="d-block w-100 px-2 pt-2">
                          {t('SELECTCOMPANY')}
                        </label>
                        <div className="radio">
                          <p className="mb-0">
                            <input
                              type="radio"
                              id="test1-view"
                              name="radio-group-view"
                              value="Fruttiboz"
                              checked={downloadInfo.company === 'Fruttiboz'}
                              onChange={handleDownloadInfoChange}
                            />
                            <label htmlFor="test1-view">{t('FRUTTIBOZ')}</label>
                          </p>
                          <p className="mb-0">
                            <input
                              type="radio"
                              id="test2-view"
                              name="radio-group-view"
                              value="Freco"
                              checked={downloadInfo.company === 'Freco'}
                              onChange={handleDownloadInfoChange}
                            />
                            <label htmlFor="test2-view">{t('FRECO')}</label>
                          </p>
                        </div>
                      </div>
                      <ul>
                        <li>
                          <a
                            className={`dropdown-item ${!downloadInfo.company ? 'disabled' : ''}`}
                            onClick={(e) => {
                              if (!downloadInfo.company) {
                                e.preventDefault();
                                return;
                              }
                              handleDownload('INVOICE');
                              setOpenDropdown(false);
                            }}
                          >
                            {t('INVOICE')}
                          </a>
                        </li>
                        <li>
                          <a
                            className={`dropdown-item ${!downloadInfo.company ? 'disabled' : ''}`}
                            onClick={(e) => {
                              if (!downloadInfo.company) {
                                e.preventDefault();
                                return;
                              }
                              handleDownload('DN');
                              setOpenDropdown(false);
                            }}
                          >
                            {t('DELIVERYNOTE')}
                          </a>
                        </li>
                        <li>
                          <a
                            className={`dropdown-item ${!downloadInfo.company ? 'disabled' : ''}`}
                            onClick={(e) => {
                              if (!downloadInfo.company) {
                                e.preventDefault();
                                return;
                              }
                              handleDownload('RECEIPT');
                              setOpenDropdown(false);
                            }}
                          >
                            {t('RECEIPT')}
                          </a>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
                <button className="pdf" onClick={handleDownloadPdf}>
                  <img src="images/pdf-without-border.svg" alt="PDF" />
                </button>
                {permissions?.[
                  isOrdersCatering
                    ? 'CATERING_ORDER_INFO_HOME_PAGE'
                    : 'FBZ_ORDER_INFO_HOME_PAGE'
                ]?.edit_permission === 1 && (
                  <button
                    className="edit"
                    onClick={() => {
                      setViewModal(false);
                      setAddModal(true);
                    }}
                  >
                    <img src="images/edit-without-border.svg" alt="Edit" />
                  </button>
                )}
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setViewModal(false)}
                ></button>
              </div>
            </div>
          </div>

          <div className="modal-body">
            <section className="first">
              <div className="row">
                <div className="col-sm-6 p-0">
                  <div className="product-inner left mx-2">
                    <ul>
                      <li>
                        <p>{t('DELIVERYDATE')}</p>
                        <span>-</span>
                        <h3>{selectedOrdersEdit?.delivery_date}</h3>
                      </li>
                      <li>
                        <p>{t('CUSTOMERCODE')}</p>
                        <span>-</span>
                        <h3>{selectedOrdersEdit?.customer?.code || ''}</h3>
                      </li>
                      <li>
                        <p>{t('CUSTOMERNAME')}</p>
                        <span>-</span>
                        <h3>{selectedOrdersEdit?.customer?.name || ''}</h3>
                      </li>
                      <li>
                        <p>{t('REFERENCENUMBER')}</p>
                        <span>-</span>
                        <h3>{selectedOrdersEdit?.reference_number || ''}</h3>
                      </li>
                      {actionFrom === 'Fbz' && (
                        <>
                          <li>
                            <p>{t('PONUMBER')}</p>
                            <span>-</span>
                            <h3>{selectedOrdersEdit?.po_number || ''}</h3>
                          </li>
                        </>
                      )}
                      <li>
                        <p>{t('DELIVERYADDRESS')}</p>
                        <span>-</span>
                        <h3>
                          {selectedOrdersEdit?.customer?.delivery_address ||
                            selectedOrdersEdit?.delivery_address ||
                            ''}
                        </h3>
                      </li>
                      <li>
                        <p>{t('DISTRICT')}</p>
                        <span>-</span>
                        <h3>
                          {selectedOrdersEdit?.customer?.district?.name ||
                            selectedOrdersEdit?.district?.name ||
                            ''}
                        </h3>
                      </li>
                      <li>
                        <p>{t('AREA')}</p>
                        <span>-</span>
                        <h3>
                          {selectedOrdersEdit?.customer?.area?.name ||
                            selectedOrdersEdit?.area?.name ||
                            ''}
                        </h3>
                      </li>
                      {actionFrom === 'Fbz' && (
                        <>
                          <li>
                            <p>{t('LOGISTICLINE')}</p>
                            <span>-</span>
                            <h3>
                              {selectedOrdersEdit?.logistic_line?.name || ''}
                            </h3>
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                </div>

                <div className="col-sm-6 p-0">
                  <div className="product-inner right mx-2">
                    <ul>
                      {actionFrom === 'Catering' && (
                        <>
                          <li>
                            <p>{t('LOGISTICLINE')}</p>
                            <span>-</span>
                            <h3>
                              {selectedOrdersEdit?.logistic_line?.name || ''}
                            </h3>
                          </li>
                        </>
                      )}
                      <li>
                        <p>{t('CONTACTPERSON')}</p>
                        <span>-</span>
                        {isOrdersCatering ? (
                          <h3>
                            {selectedOrdersEdit?.customer?.contact_name || ''}
                          </h3>
                        ) : (
                          <h3>{selectedOrdersEdit?.contact_name || ''}</h3>
                        )}
                      </li>
                      <li>
                        <p>{t('CONTACTPHONENO')}</p>
                        <span>-</span>
                        {isOrdersCatering ? (
                          <h3>
                            {selectedOrdersEdit?.customer?.contact_phone || ''}
                          </h3>
                        ) : (
                          <h3>{selectedOrdersEdit?.contact_phone || ''}</h3>
                        )}
                      </li>
                      <li>
                        <p>{t('PAYMENTMETHOD')}</p>
                        <span>-</span>
                        <h3>
                          {selectedOrdersEdit?.customer?.payment_method?.name ||
                            selectedOrdersEdit?.payment_method?.name ||
                            ''}
                        </h3>
                      </li>
                      <li>
                        <p>{t('PAYMENTSTATUS')}</p>
                        <span>-</span>
                        <h3>
                          {selectedOrdersEdit?.payment_status?.name || ''}
                        </h3>
                      </li>
                      <li>
                        <p>{t('PAYMENTDATE')}</p>
                        <span>-</span>
                        <h3>{selectedOrdersEdit?.payment_date || ''}</h3>
                      </li>
                      <li>
                        <p>{t('ORDERREMARK')}</p>
                        <span>-</span>
                        <h3>{selectedOrdersEdit?.remark || ''}</h3>
                      </li>
                      {actionFrom === 'Fbz' && (
                        <>
                          <li>
                            <p>{t('ADDITIONALFEE')}</p>
                            <span>-</span>
                            <h3>
                              {selectedOrdersEdit?.additional_fee
                                ? `$${selectedOrdersEdit.additional_fee}`
                                : ''}
                            </h3>
                          </li>
                          <li>
                            <p>{t('EARLIESTDELIVERYTIME')}</p>
                            <span>-</span>
                            <h3>
                              {selectedOrdersEdit?.earliest_delivery_time
                                ? convertTo12HourFormat(
                                    selectedOrdersEdit.earliest_delivery_time
                                  )
                                : '--:--'}
                            </h3>
                          </li>
                          <li>
                            <p>{t('LATESTDELIVERYTIME')}</p>
                            <span>-</span>
                            <h3>
                              {selectedOrdersEdit?.latest_delivery_time
                                ? convertTo12HourFormat(
                                    selectedOrdersEdit.latest_delivery_time
                                  )
                                : '--:--'}
                            </h3>
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="product-info">
                <h1>{t('PRODUCTSINFO')}</h1>
              </div>

              <div className="table-outer view-order">
                <table className="table">
                  <thead>
                    <tr className="t-heading">
                      <th className="id">
                        <h5>#</h5>
                      </th>
                      <th className="code">
                        <h5>{t('PRODUCTCODE')}</h5>
                      </th>
                      <th className="name">
                        <h5>{t('PRODUCTNAME')}</h5>
                      </th>
                      <th className="origin">
                        <h5>{t('ORIGIN')}</h5>
                      </th>
                      <th className="specification">
                        <h5>{t('SPECIFICATION')}</h5>
                      </th>
                      <th className="quantity">
                        <h5>{t('QUANTITY')}</h5>
                      </th>
                      {actionFrom === 'Fbz' && (
                        <>
                          <th className="unit-price">
                            <h5>{t('UNITPRICE')}</h5>
                          </th>
                          <th className="discount">
                            <h5>{t('DISCOUNT')}</h5>
                          </th>
                        </>
                      )}
                      <th className="remark">
                        <h5>{t('PRODUCTREMARK')}</h5>
                      </th>
                      <th className="location">
                        <h5>{t('PROCESSLOCATION')}</h5>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedOrdersEdit?.products?.map((product, index) => (
                      <tr key={product.id}>
                        <td className="id">
                          <h5>{index + 1}</h5>
                        </td>
                        <td className="code">
                          <h5>{product?.product_code || ''}</h5>
                        </td>
                        <td className="name">
                          <h5>{product?.product_name || ''}</h5>
                        </td>
                        <td className="origin">
                          <h5>{product?.origin?.name || ''}</h5>
                        </td>
                        <td className="specification">
                          <h5>{formatSpecification(product)}</h5>
                        </td>
                        <td className="quantity">
                          {/* <h5>{product?.quantity || ''}</h5> */}
                          <h5>{trimDecimalZero(product?.quantity)}</h5>
                        </td>
                        {actionFrom === 'Fbz' && (
                          <>
                            <td className="unit-price">
                              <h5>
                                {product?.unit_price
                                  ? `$${product.unit_price}`
                                  : ''}
                              </h5>
                            </td>
                            <td className="discount">
                              <h5>
                                {product?.discount
                                  ? `$${product.discount}`
                                  : ''}
                              </h5>
                            </td>
                          </>
                        )}
                        <td className="remark">
                          <h5>{product?.remarks || ''}</h5>
                        </td>
                        <td className="location">
                          <h5>{product?.process_location?.name || ''}</h5>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOrderModal;
